import Reveal from '@/components/feature/Reveal';

const facts = [
  { icon: 'ri-map-pin-line', title: 'California', detail: 'Based in Windsor, Sonoma County' },
  { icon: 'ri-goblet-line', title: 'Craft Brewing', detail: 'Independent brewing business' },
  { icon: 'ri-user-star-line', title: 'Owner', detail: 'Vinnie Cilurzo' },
];

export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal className="relative">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20close-up%20of%20a%20glass%20of%20amber%20craft%20beer%20on%20a%20rustic%20wooden%20bar%20counter%2C%20warm%20copper%20and%20amber%20tones%2C%20soft%20window%20light%2C%20vintage%20artisanal%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20premium%20craft%20brewery%20mood%2C%20rich%20warm%20colors%2C%20elegant%20minimal%20styling&width=900&height=1100&seq=brewery-about-02&orientation=portrait"
                alt="Amber craft beer on a rustic wooden bar counter with warm copper tones"
                title="23 Bottles of Beer — craftsmanship and quality"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 md:w-32 md:h-32 rounded-lg bg-primary-500/90 flex items-center justify-center">
              <span className="font-heading font-semibold text-3xl md:text-4xl text-background-50">23</span>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <p className="text-xs tracking-[0.35em] uppercase text-primary-600 mb-4">About</p>
            <h2 className="font-heading font-semibold text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-950">
              About 23 Bottles of Beer
            </h2>

            <p className="mt-6 text-foreground-600 leading-relaxed">
              23 Bottles of Beer LLC is a California-based craft brewing business focused on
              the art and character of independent brewing. Rooted in the traditions of
              American craft beer, the company represents a commitment to quality,
              distinctive brewing, and the culture surrounding great beer.
            </p>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              Based in Windsor, California, 23 Bottles of Beer LLC operates from the heart
              of Sonoma County&rsquo;s wine and craft beverage country.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 border-t border-background-200/70 pt-8">
              {facts.map((f) => (
                <div key={f.title} className="flex flex-col gap-2">
                  <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className={`${f.icon} text-lg`}></i>
                  </span>
                  <span className="font-semibold text-foreground-900 text-sm">{f.title}</span>
                  <span className="text-sm text-foreground-500 leading-snug">{f.detail}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}